
  document.addEventListener('DOMContentLoaded', function () {
    var scrollToTopButton = document.getElementById('scroll-to-top-button-sections--33094172213573__back_to_top_Ca7nbV');

    scrollToTopButton.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    const scrollThreshold = 1 - 60 / 100;

    function toggleScrollToTopButton() {
      if (window.scrollY > scrollThreshold * (document.body.scrollHeight - window.innerHeight)) {
        scrollToTopButton.style.display = 'block';
        setTimeout(() => (scrollToTopButton.style.opacity = '1'), 10);
      } else {
        scrollToTopButton.style.opacity = '0';
        setTimeout(() => (scrollToTopButton.style.display = 'none'), 300);
      }
    }

    if (scrollThreshold === 1) {
      scrollToTopButton.style.display = 'block';
      scrollToTopButton.style.opacity = '1';
    } else {
      window.addEventListener('scroll', toggleScrollToTopButton);
    }
  });
